import useRepo from '@/nebula/repo';
import { savedView as savedViewConfig } from 'shared/api/query/configs.json';

export default function useSavedViewRepo() {
  return useRepo(savedViewConfig.model);
}
